"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Accordion = _interopRequireDefault(require("@cimpress/react-components/lib/Accordion"));

var _core = require("@emotion/core");

var AccordionWrapper = function AccordionWrapper(props) {
  return (0, _core.jsx)(_Accordion["default"], (0, _extends2["default"])({
    style: {
      margin: 0
    },
    headerStyle: {
      padding: 0
    },
    bodyStyle: {
      paddingBottom: 0
    }
  }, props));
};

var _default = AccordionWrapper;
exports["default"] = _default;